export default __webpack_public_path__ + "static/media/apple-card.041f27c1.jpg";